import React, { HTMLAttributes } from 'react'
import { Plus } from 'react-feather'

import { Button } from '@frame/ui-primitives/button'
import { H4 } from '@frame/ui-primitives/h4'

import { cn } from '@frame/lib/utils/cn'
import { DataAttribute } from '@frame/types'

import { HoverOverlay } from '../direct-task-card/hover-overlay'

type Props = {
  onClick?: () => void
  className?: HTMLAttributes<HTMLDivElement>['className']
}

export function AddEmployerButton({ onClick, className }: Props) {
  return (
    <div
      tabIndex={0}
      data-cy={DataAttribute.ADD_EMPLOYER}
      className={cn('group relative', className)}
      onClick={onClick}
      onKeyDown={(e) => e.key === 'Enter' && onClick && onClick()}
    >
      <HoverOverlay />
      <div
        className={cn(
          'relative z-30 flex h-[76px] items-center justify-between rounded-md px-4 py-2 hover:cursor-pointer',
          className
        )}
      >
        <div className="z-40">
          <H4 className="text-cobranding">Add Employer</H4>
        </div>
        <Button
          tabIndex={-1}
          Icon={Plus}
          intent="tertiary"
          className="relative z-40 flex h-6 w-6 items-center rounded-full border-cobranding text-cobranding hover:border-cobranding group-hover:-translate-y-[2px] group-hover:bg-cobranding group-hover:text-white group-hover:shadow-floatingButton"
          aria-label="Add Employer"
        />
      </div>
    </div>
  )
}
